import React from 'react';
import styles from './style.module.scss';
import moment from 'moment';
import Skeleton from 'antd/es/skeleton';
import Image from '../../../../components/general/antd/image';
interface MessageProps {
  message: {
    body: string | null;
    file: string | null;
    sender_name: string;
    created_at: string;
    typeForAdmin: string;
    status?: "sending" | "sent" | "failed";
  };
}

export const MessageCart: React.FC<MessageProps> = ({ message }) => {

  return (
    <div className={`${styles.message} ${message.typeForAdmin === 'admin' ? styles.left : styles.right}`}>
      {message.body && <div>{message.body}</div>}

      {message.file && 
        <div className={styles.attachment}>
          
            <>
              {message.status === "sending" ? (
                <Skeleton.Image active style={{ width: 150, height: 150 }} />
              ) : (
                <Image src={message.file} alt="مرفق" className={styles.imagePreview} preview={true} inChat={true}/>
                // <img src={message.file} alt="مرفق" className={styles.imagePreview} />
              )}
            </>
        </div>
          }
      
      {message.status === "sending" && (
        <small className={styles["message-status"]}>جاري الإرسال...</small>
      )}
      {message.status === "failed" && (
        <small className={styles["message-status"]} style={{ color: "red" }}>
          فشل الإرسال
        </small>
      )}

      <small className={styles["message-time"]}>
        {moment(message.created_at).format("H:mm")}
      </small>
    </div>
  );
};